var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1 5.95l-1.15-.3-1.05.3-.3 1.1.3 1.05 1.1.3 1.1-.3.3-1.1-.3-1.05zm2.35-2.25l1.899.45c.434 0 .834.15 1.2.45.301.333.451.7.451 1.1V8.3c-.033.434-.2.816-.5 1.15-.333.3-.717.45-1.15.45l-1.899.5-.551 2.05c0 .399-.15.767-.45 1.1-.3.3-.667.45-1.1.45H5.7c-.4 0-.767-.15-1.1-.45-.333-.333-.483-.7-.45-1.1l-.55-2L1.65 10a2.213 2.213 0 0 1-1.2-.55c-.3-.3-.45-.667-.45-1.1v-2.2-.45c0-.4.183-.767.55-1.1.267-.3.633-.45 1.1-.45L3.6 3.6l.5-1.95c0-.2.017-.383.05-.55a.958.958 0 0 1 .4-.55C4.85.183 5.233 0 5.7 0h2.2c.1 0 .234.017.4.05.434 0 .816.167 1.15.5.166.133.283.317.35.55.033.167.066.35.1.55l.55 2.05z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/food.e765db40991f8e153607ad91ef540eae.svg";
export { ForwardRef as ReactComponent };